export default __webpack_public_path__ + "static/nftreplicas-a60acab859833d62150eedceeb1a372f.jpeg";